// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Yu-z","tooltipWrapper":"Zu-z","icon":"_u-z","tooltip":"av-z","content":"bv-z"};